import { colorPaletteTheme as color } from './color';

export const textTheme = {
  default: color.secondary,
  gray: color.grayScale.dark,
  time: '#6a6b69',
  white: color.white,
  error: color.error,
} as const;
